<template lang="pug">
  div
    .van-toast.van-toast--default.van-toast--middle(style="z-index: 3009")
      i.van-icon.van-icon-fail.van-toast__icon
      .van-toast__text {{ message }}
    .van-modal(style="z-index: 3008")
</template>

<script>
export default {
  props: {
    message: {
      type: String,
      default: '',
    },
  },
};
</script>
